import { Box, Tooltip, Typography, IconButton } from '@mui/material';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import TooltipContent from './TooltipContent';
import { sxConfig } from './calendarStyle';
import dayjs from 'dayjs';
import colorFinder from '../../utils/colorFinder';
import useParam from '../../context/ParamContext';
import { useEffect, useState } from 'react';
import { formatValue } from '../../utils/resource.planner';

const SimpleTaskEventContent = ({ eventInfo, setShowSimpleTaskReportDialog }) => {
  const { params } = useParam();
  const [chipObj, setChipObj] = useState(null);

  useEffect(() => {
    let paramKey = 'TASKCALENDAR_CHIP_CONTENT';

    if (params[paramKey]) {
      const parsedObj = JSON.parse(params[paramKey]);
      setChipObj(parsedObj);
    }
  }, [params]);

  const eventData = eventInfo.event.extendedProps;
  const status = eventData.status?.color;
  const title = eventInfo.event.title;

  const color = colorFinder(status);
  const textColor = color.textColor || '#000';

  const getFieldValue = (obj, path) => {
    return path.split('.').reduce((acc, part) => {
      if (Array.isArray(acc)) {
        return acc.map((item) => item[part]);
      }
      return acc ? acc[part] : null;
    }, obj);
  };

  const setChipContent = () => {
    if (!chipObj || !eventData) {
      return null;
    }

    return (
      <Typography component="span">
        {chipObj.map((item, index) => {
          const { label, fieldName, type } = item;
          const taskValue = getFieldValue(eventData, fieldName);

          return (
            <Typography key={index} component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
              {label}: {formatValue(taskValue, type)}
            </Typography>
          );
        })}
      </Typography>
    );
  };

  const chipContent = setChipContent();

  return (
    <Tooltip
      arrow
      placement="top"
      title={<TooltipContent eventInfo={eventInfo} />}
      slotProps={{
        tooltip: {
          sx: {
            ...sxConfig.tooltip,
            maxWidth: 500,
          },
        },
        arrow: { sx: sxConfig.tooltipArrow },
      }}
    >
      <Box
        sx={{
          ...sxConfig.eventBox,
          backgroundColor: color.colorBgCode,
          borderLeft: `3px solid ${textColor}`,
          display: 'grid',
          gridTemplateColumns:
            params.SHOW_TASK_CALENDAR_SIMPLETASK_REPORT_ICON === 'Y'
              ? {
                  xs: 'minmax(0, 1fr) 80px',
                  md: 'minmax(0, 1fr) 50px',
                }
              : 'minmax(0, 1fr)',
          alignItems: 'center',
          gap: 0.5,
        }}
      >
        {chipContent ||
          (eventInfo?.view?.type === 'dayGridMonth' ? (
            <Box>
              <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                {title}
              </Typography>
            </Box>
          ) : (
            <Box>
              <Box>
                <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                  F: {title}
                </Typography>
              </Box>
              <Box>
                <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                  P: {eventData.project?.projectName}
                </Typography>
              </Box>
              <Box>
                <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                  K: {dayjs(eventData.startDate).format('YYYY-MM-DD HH:mm')}
                </Typography>
              </Box>
              <Box>
                <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                  H: {dayjs(eventData.endDate).format('YYYY-MM-DD HH:mm')}
                </Typography>
              </Box>
              <Box>
                <Typography component="span" sx={{ ...sxConfig.eventTitle, color: textColor }}>
                  F: {eventData.responsiblePerson?.nickName}
                </Typography>
              </Box>
            </Box>
          ))}
        {params.SHOW_TASK_CALENDAR_SIMPLETASK_REPORT_ICON === 'Y' && (
          <Box sx={sxConfig.reportIconContainer}>
            <IconButton
              sx={sxConfig.reportIconButton}
              onClick={async (e) => {
                e.stopPropagation();
                setShowSimpleTaskReportDialog({
                  open: true,
                  data: {
                    projectId: eventData?.projectId,
                    ...(params.SHOW_EMPLOYEE_ATTENDANCE_SIMPLETASK_FIELD === 'Y' && {
                      simpleTaskId: eventData?.simpleTaskId,
                      simpleTaskName: eventData?.simpleTaskName,
                    }),
                  },
                });
              }}
            >
              <AccessTimeIcon sx={sxConfig.reportIcon} />
            </IconButton>
          </Box>
        )}
      </Box>
    </Tooltip>
  );
};

export default SimpleTaskEventContent;
